/**
 * Server Finance Constants
 *
 * Copies of the server's values (game-server/modules/ponder-flight-game/):
 * TicksPerQuarter from finance/ledger.go, QuartersPerYear from
 * finance/cfo.go, DaysPerTick from time.go, and the strength range from
 * finance/policy.go. A Go test reads this file and fails when a value here
 * and the server's differ (client_parity_test.go), and when a constant is
 * added here without naming the server value it copies.
 */

// Number of simulation ticks that make up one quarter.
export const TicksPerQuarter = 3;

// Number of quarters in a year.
export const QuartersPerYear = 4;

// Number of days represented by each simulation tick.
export const DaysPerTick = 30;

// A team's strength score: its baseline before margin and leverage move it,
// and the range it is clamped to (finance/policy.go, DefaultPolicy's
// StrengthBaseValue, StrengthMinValue and StrengthMaxValue).
export const StrengthBase = 1.0;
export const StrengthMin = 0.25;
export const StrengthMax = 2.0;
